var _radialGradient, _path, _linearGradient, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharedImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "5GYmV7yt80nOY1s3AxI73a",
    cx: 32,
    cy: 32,
    r: 33.002,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2e0bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#f2e0bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    stopColor: "#f9edd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#fef4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff7e4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#5GYmV7yt80nOY1s3AxI73a)",
    d: "M55.454,45.668c0.5,0.898,1.504,1.337,2.532,1.332c1.75-0.008,3.153,1.483,3.002,3.262 C60.855,51.838,59.434,53,57.852,53L48,53v1H26h-8H7c-1.71,0-3.086-1.431-2.996-3.161C4.089,49.216,5.545,48,7.17,48L8,48 c1.215,0,2.176-1.083,1.973-2.336C9.813,44.681,8.889,44,7.893,44L3,44c-1.71,0-3.086-1.431-2.996-3.161 C0.089,39.216,1.545,38,3.17,38l6.33,0c1.381,0,2.5-1.119,2.5-2.5v0c0-1.381-1.119-2.5-2.5-2.5h0C8.119,33,7,31.881,7,30.5v0 C7,29.119,8.119,28,9.5,28H18v-7h-7.5c-1.995,0-3.601-1.67-3.495-3.688C7.104,15.419,8.803,14,10.698,14L18,14v-4h24h6h8.5 c1.995,0,3.601,1.67,3.495,3.688C59.896,15.581,58.197,17,56.302,17L53.5,17c-1.995,0-3.601,1.67-3.495,3.688 C50.104,22.581,51.803,24,53.698,24L56,24c1.777,0,3.194,1.546,2.978,3.366c-0.179,1.509-1.546,2.572-3.064,2.635 c-1.197,0.05-2.122,1.153-1.874,2.406C54.228,33.355,55.123,34,56.089,34H60.5c1.995,0,3.601,1.67,3.495,3.688 C63.896,39.581,62.197,41,60.302,41L58,41C55.808,41,54.166,43.35,55.454,45.668z M2.5,33L2.5,33C3.881,33,5,31.881,5,30.5v0 C5,29.119,3.881,28,2.5,28h0C1.119,28,0,29.119,0,30.5v0C0,31.881,1.119,33,2.5,33z M2.5,33L2.5,33C3.881,33,5,31.881,5,30.5v0 C5,29.119,3.881,28,2.5,28h0C1.119,28,0,29.119,0,30.5v0C0,31.881,1.119,33,2.5,33z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "5GYmV7yt80nOY1s3AxI73b",
    x1: 33,
    x2: 33,
    y1: 58,
    y2: 6,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41bfec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#4cc5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#6bd4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ae4fd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#5GYmV7yt80nOY1s3AxI73b)",
    d: "M50,58H16c-1.657,0-3-1.343-3-3V9c0-1.657,1.343-3,3-3h20.757 c0.796,0,1.559,0.316,2.121,0.879l13.243,13.243C52.684,20.684,53,21.447,53,22.243V55C53,56.657,51.657,58,50,58z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "5GYmV7yt80nOY1s3AxI73c",
    x1: 38.879,
    x2: 46.454,
    y1: 20.121,
    y2: 12.546,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6effd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#b7ecfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95e6fd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#5GYmV7yt80nOY1s3AxI73c)",
    d: "M52.121,20.122L38.878,6.879c-0.255-0.255-0.556-0.452-0.878-0.6V18c0,1.657,1.343,3,3,3 h11.721C52.574,20.678,52.377,20.377,52.121,20.122z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "5GYmV7yt80nOY1s3AxI73d",
    x1: 45.5,
    x2: 45.5,
    y1: 24.083,
    y2: 18.083,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42c6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3bc3ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ebeea"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#5GYmV7yt80nOY1s3AxI73d)",
    d: "M41,21c-1.657,0-3-1.343-3-3v3c0,1.657,1.343,3,3,3h12v-1.757 c0-0.434-0.102-0.855-0.279-1.243H41z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "5GYmV7yt80nOY1s3AxI73e",
    x1: 22,
    x2: 22,
    y1: 21,
    y2: 6,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81dcf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8ce1f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ee8fd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#5GYmV7yt80nOY1s3AxI73e)",
    d: "M21.5,21H13V9c0-1.657,1.343-3,3-3h9.5C26.881,6,28,7.119,28,8.5v0 c0,1.381-1.119,2.5-2.5,2.5h-5c-1.381,0-2.5,1.119-2.5,2.5v0c0,1.381,1.119,2.5,2.5,2.5h1c1.381,0,2.5,1.119,2.5,2.5v0 C24,19.881,22.881,21,21.5,21z M29,17c-1.105,0-2,0.895-2,2s0.895,2,2,2c1.105,0,2-0.895,2-2S30.105,17,29,17z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.208,33.145L19.187,44.42C18.716,45.082,19.189,46,20.002,46h16.042 c0.812,0,1.286-0.918,0.815-1.58l-8.021-11.275C28.439,32.585,27.606,32.585,27.208,33.145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.123 36.976l-5.92 7.399C32.679 45.03 33.145 46 33.984 46h11.84c.839 0 1.305-.97.781-1.625l-5.92-7.399C40.285 36.476 39.524 36.476 39.123 36.976zM42.982 29A2 2 0 1 0 42.982 33 2 2 0 1 0 42.982 29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedImage);
export default __webpack_public_path__ + "static/media/Shared-Image.aa785c0b18778689773d9dee1ef293ff.svg";
export { ForwardRef as ReactComponent };